import copyCodeGreenIcon from "../../../../../../../../../assets/icons/copy_code_green.svg";

import boletoViewGreenIcon from "../../../../../../../../../assets/icons/boleto_view _green.svg";

import { TabelaAcordoParcelas } from "../tabela";
import { Button } from "../../../../../../../../generics/button";
import { useContrato } from "../../../../../../../../../context/ContratoContext";
import { CanaisEnvio } from '../canais-envio'

export const ResumoAcordoAccordion = () => {
  const { negociarAcordo } = useContrato();

  function goToOpeningAccordion() {
    const element = document.getElementById("acordo");
    if (element) {
      document.getElementById("acordo")?.setAttribute("open", "true");
      element.scrollIntoView({ behavior: "smooth" });
    }
  }
  return (
    <details
      id="resumo"
      className="mb-3 w-full border border-gray-300 bg-white"
    >
      <summary className="flex w-full cursor-pointer justify-between bg-white px-4 py-3 text-xl font-medium text-gray-800 after:content-['+']">
        Resumo Contra Proposta
      </summary>

      <div className="px-4 py-2">
        <div className="flex w-full gap-4 ">
          <div className="flex h-full w-1/2 flex-col items-center">
            <p className="font-medium text-primary ">
              Operações envolvidas no acordo
            </p>
            <div>
              <TabelaAcordoParcelas />
            </div>
          </div>

          <div className="flex w-1/2 flex-col items-center rounded bg-gray-100 p-4 text-right">
            <p className="font-medium text-primary ">Detalhes da negociação</p>
            <div className="my-4 grid grid-cols-2 gap-4 text-sm text-gray-800">
              <strong>Tipo de negociação: </strong>
              <p>A vista</p>

              <strong>Forma de pagamento: </strong>
              <p>PIX</p>

              <strong>Valor da entrada: </strong>
              <p>R$ 5.635,20</p>


              <strong>Vencimento: </strong>
              <p>20/11/2023</p>

              {/* <strong>Valor atualizado: </strong>
              <p>R$ 1.500,00</p> */}

              <strong>Total a pagar: </strong>
              <p>R$ 1.500,00</p>
            </div>
          </div>
        </div>

        <div className="my-4 flex items-center justify-evenly  ">
          <CanaisEnvio />
        </div>

        <div>
          <div className="my-4 flex items-center justify-evenly  ">
            <div className="flex w-full items-center justify-center">
              <button className="flex items-center  gap-4  text-primary underline">
                <img src={copyCodeGreenIcon} alt="" />
                Copiar resumo
              </button>
            </div>
            <div className="flex flex-col items-center gap-4 w-full">
              <Button
                name="Anexar PDF ou Link "
                width="w-[97%]"
              // onClick={() => {
              //   negociarAcordo();
              //   goToOpeningAccordion();
              // }}
              />

            </div>

          </div>

          <Button
            name="Efetivar Proposta"
            width="w-[100%]"
            background="bg-green-600"

          // onClick={() => {
          //   negociarAcordo();
          //   goToOpeningAccordion();
          // }}
          />
        </div>
      </div>
    </details>
  );
};
